/* eslint-disable */
// @ts-nocheck
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: unknown; output: unknown; }
  Upload: { input: unknown; output: unknown; }
};

export enum AppointmentType {
  Grooming = 'GROOMING',
  RoutineCheckup = 'ROUTINE_CHECKUP',
  Sick = 'SICK',
  SickUrgent = 'SICK_URGENT',
  TechAppt = 'TECH_APPT',
  VaccineBooster = 'VACCINE_BOOSTER'
}

export type AvailableSlot = {
  __typename?: 'AvailableSlot';
  date: Scalars['String']['output'];
  provider?: Maybe<AvailableSlotProvider>;
  providerId?: Maybe<Scalars['String']['output']>;
  time: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AvailableSlotProvider = {
  __typename?: 'AvailableSlotProvider';
  username?: Maybe<Scalars['String']['output']>;
};

export type BffAdditionalInfo = {
  __typename?: 'BffAdditionalInfo';
  available_categories?: Maybe<Scalars['String']['output']>;
  available_services?: Maybe<Scalars['String']['output']>;
  can_book?: Maybe<Scalars['Boolean']['output']>;
  cancellation_fee_duration?: Maybe<Scalars['Int']['output']>;
  categories_available?: Maybe<Scalars['Boolean']['output']>;
  center_amenities?: Maybe<Scalars['String']['output']>;
  collect_feedback?: Maybe<Scalars['String']['output']>;
  cst?: Maybe<Scalars['String']['output']>;
  feedback_label?: Maybe<Scalars['String']['output']>;
  feedback_link?: Maybe<Scalars['String']['output']>;
  is_add_ons_available?: Maybe<Scalars['Boolean']['output']>;
  is_auto_pay_enabled_at_center?: Maybe<Scalars['Boolean']['output']>;
  is_center_amenities_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_global_tokenization_supported?: Maybe<Scalars['Boolean']['output']>;
  service_tax_no?: Maybe<Scalars['String']['output']>;
  services_available?: Maybe<Scalars['Boolean']['output']>;
  tin?: Maybe<Scalars['String']['output']>;
  unavailable_categories?: Maybe<Scalars['String']['output']>;
  unavailable_services?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type BffAddress = {
  __typename?: 'BffAddress';
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type BffBlog = {
  __typename?: 'BffBlog';
  blogImage?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  timeToRead?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BffBrand = {
  __typename?: 'BffBrand';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<BffBrandType>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum BffBrandType {
  AspenDental = 'ASPEN_DENTAL',
  AzPet = 'AZ_PET',
  Chapter = 'CHAPTER',
  ClearChoice = 'CLEAR_CHOICE',
  Lovet = 'LOVET',
  Motto = 'MOTTO',
  WellNow = 'WELL_NOW'
}

export type BffBrazeUserAttributes = {
  __typename?: 'BffBrazeUserAttributes';
  custom_attributes?: Maybe<Scalars['JSON']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
};

export type BffCacheLineStats = {
  __typename?: 'BffCacheLineStats';
  cachedAt?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  secTTL?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type BffCenter = {
  __typename?: 'BffCenter';
  additional_info?: Maybe<BffAdditionalInfo>;
  address_info?: Maybe<BffAddress>;
  code?: Maybe<Scalars['String']['output']>;
  contact_info?: Maybe<BffContactInfo>;
  country?: Maybe<BffCountry>;
  culture_code_at_center?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<BffCurrency>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  enable_parallel_services_at_center?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_fbe_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_hc_call_center?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<BffLocation>;
  name?: Maybe<Scalars['String']['output']>;
  online_booking_start_date?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['String']['output']>;
  state?: Maybe<BffState>;
  working_hours?: Maybe<Array<Maybe<BffWorkinghours>>>;
};

export type BffCenters = {
  __typename?: 'BffCenters';
  centers?: Maybe<Array<Maybe<BffCenter>>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type BffCertifications = {
  __typename?: 'BffCertifications';
  certification?: Maybe<Scalars['String']['output']>;
  certificationCountry?: Maybe<Scalars['String']['output']>;
  certificationName?: Maybe<Scalars['String']['output']>;
  certifierOrIssuer?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['String']['output']>;
};

export type BffCity = {
  __typename?: 'BffCity';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type BffClient = {
  __typename?: 'BffClient';
  addresses?: Maybe<Array<Maybe<BffClientAddress>>>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffClientAddress = {
  __typename?: 'BffClientAddress';
  city?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type BffClientList = {
  __typename?: 'BffClientList';
  clients?: Maybe<Array<Maybe<BffClient>>>;
  errors?: Maybe<Array<Maybe<BffError>>>;
};

export type BffContactInfo = {
  __typename?: 'BffContactInfo';
  email?: Maybe<Scalars['String']['output']>;
  phone_1?: Maybe<BffPhoneNumber>;
  phone_2?: Maybe<BffPhoneNumber>;
};

export type BffCountry = {
  __typename?: 'BffCountry';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone_code?: Maybe<Scalars['Int']['output']>;
};

export type BffCredentials = {
  __typename?: 'BffCredentials';
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['String']['output']>;
};

export type BffCurrency = {
  __typename?: 'BffCurrency';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type BffDamAsset = {
  __typename?: 'BffDamAsset';
  height?: Maybe<Scalars['Int']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type BffError = {
  __typename?: 'BffError';
  message?: Maybe<Scalars['String']['output']>;
};

export type BffEstimate = {
  __typename?: 'BffEstimate';
  client?: Maybe<BffClient>;
  datetime?: Maybe<Scalars['String']['output']>;
  highTotal?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lowTotal?: Maybe<Scalars['Float']['output']>;
  patients?: Maybe<Array<Maybe<BffClient>>>;
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * An office facility
 * Brick and Mortar part of **business** [API](http://example.com)!
 */
export type BffFacility = {
  __typename?: 'BffFacility';
  address?: Maybe<BffFacilityAddress>;
  anytimeAppointingDenture?: Maybe<Scalars['Boolean']['output']>;
  anytimeAppointingMotto?: Maybe<Scalars['Boolean']['output']>;
  attributes?: Maybe<Array<Maybe<NamedAttribute>>>;
  bilingual?: Maybe<Scalars['Boolean']['output']>;
  birdeyeBusinessId?: Maybe<Scalars['String']['output']>;
  /** Brand where the data is from */
  brand?: Maybe<Scalars['String']['output']>;
  clinicType?: Maybe<Scalars['String']['output']>;
  clockwiseId?: Maybe<Scalars['String']['output']>;
  /** Facility Code or Id */
  code: Scalars['String']['output'];
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  currentBrand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Scalars['String']['output']>;
  dnis?: Maybe<Scalars['String']['output']>;
  doctors?: Maybe<Array<Maybe<BffProvider>>>;
  email?: Maybe<Scalars['String']['output']>;
  emergencyPhoneNumber?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstThreeOctets?: Maybe<Scalars['String']['output']>;
  fullClinicNameWithBrand?: Maybe<Scalars['String']['output']>;
  geomodifier?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  implants?: Maybe<Scalars['String']['output']>;
  insurance?: Maybe<Array<Maybe<BffInsurance>>>;
  insuranceNetwork?: Maybe<Array<Maybe<BffInsurance>>>;
  landmarks?: Maybe<Scalars['String']['output']>;
  legalBillingName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BffFacilityLocation>;
  metroRegion?: Maybe<Scalars['String']['output']>;
  metroRegionSlug?: Maybe<Scalars['String']['output']>;
  minimumPatientAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsBasedQuestions?: Maybe<Scalars['Boolean']['output']>;
  neighboringAreas?: Maybe<Scalars['String']['output']>;
  onHVP?: Maybe<Scalars['Boolean']['output']>;
  onMotto?: Maybe<Scalars['Boolean']['output']>;
  onP3?: Maybe<Scalars['Boolean']['output']>;
  openDate?: Maybe<Scalars['String']['output']>;
  originalBrand?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pilot1?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  reviewSummary?: Maybe<BffFacilityReviewSummary>;
  reviews?: Maybe<BffReviews>;
  revspringAccountId?: Maybe<Scalars['String']['output']>;
  revspringLocationValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Always returns null. Use salesStatusGrpc instead. */
  salesStatus?: Maybe<Scalars['String']['output']>;
  salesStatusGrpc?: Maybe<BffSalesStatus>;
  scheduleAppointmentURL?: Maybe<Scalars['String']['output']>;
  schedulingSystem?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<BffService>>>;
  siteGroup?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  specialtyServices?: Maybe<Array<Maybe<BffSpecialtyService>>>;
  status?: Maybe<Scalars['String']['output']>;
  workingHours?: Maybe<Array<Maybe<BffWorkingHours>>>;
};

export type BffFacilityAddress = {
  __typename?: 'BffFacilityAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BffFacilityCollection = {
  __typename?: 'BffFacilityCollection';
  items?: Maybe<Array<Maybe<BffFacility>>>;
  returned?: Maybe<Scalars['Int']['output']>;
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BffFacilityLocation = {
  __typename?: 'BffFacilityLocation';
  directions?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  landmarks?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  neighboringAreas?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timezoneIANA?: Maybe<Scalars['String']['output']>;
};

export type BffFacilityReviewSummary = {
  __typename?: 'BffFacilityReviewSummary';
  summaryText: Scalars['String']['output'];
  thingsToKeepInMind: Array<Scalars['String']['output']>;
  whatPatientsLike: Array<Scalars['String']['output']>;
};

export type BffFacilityScheduleType = {
  __typename?: 'BffFacilityScheduleType';
  id: Scalars['String']['output'];
  scheduleType?: Maybe<Scalars['String']['output']>;
};

export type BffFutureDays = {
  __typename?: 'BffFutureDays';
  Day?: Maybe<Scalars['String']['output']>;
  HolidayType?: Maybe<Scalars['String']['output']>;
  IsAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type BffGeocodeResult = {
  __typename?: 'BffGeocodeResult';
  formattedAddress?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type BffInsurance = {
  __typename?: 'BffInsurance';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffLocation = {
  __typename?: 'BffLocation';
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<BffTimezone>;
};

export type BffLocationAvailability = {
  __typename?: 'BffLocationAvailability';
  appointmentSlotMinutes: Scalars['Int']['output'];
  availableSlots: Array<AvailableSlot>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BffOrder = {
  __typename?: 'BffOrder';
  client?: Maybe<BffClient>;
  datetime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  patients?: Maybe<Array<Maybe<BffClient>>>;
  totalAfterTaxCents?: Maybe<Scalars['Float']['output']>;
};

export type BffPhoneNumber = {
  __typename?: 'BffPhoneNumber';
  country_id?: Maybe<Scalars['Int']['output']>;
  display_number?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type BffPriceInfo = {
  __typename?: 'BffPriceInfo';
  currency_id?: Maybe<Scalars['Int']['output']>;
  demand_group_id?: Maybe<Scalars['String']['output']>;
  include_tax?: Maybe<Scalars['Boolean']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  ssg?: Maybe<Scalars['Int']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
};

export type BffProduct = {
  __typename?: 'BffProduct';
  brand: Scalars['String']['output'];
  brandfolderImageAssetUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  procedures?: Maybe<Array<Maybe<BffProductProcedure>>>;
  subCategory?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Float']['output'];
};

export type BffProductProcedure = {
  __typename?: 'BffProductProcedure';
  /** The price for the procedure, it can be average if not sought by facility, or specific to the facility selected. */
  price: Scalars['Float']['output'];
  procedureCode: Scalars['String']['output'];
  procedureDescription: Scalars['String']['output'];
};

export type BffProvider = {
  __typename?: 'BffProvider';
  active?: Maybe<Scalars['Boolean']['output']>;
  associations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  biography?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<Maybe<BffCertifications>>>;
  collegeCity?: Maybe<Scalars['String']['output']>;
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  degreeNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  educations?: Maybe<Array<Maybe<BffCredentials>>>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeStatus?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<Maybe<BffFacility>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<BffProviderLicense>>>;
  mainWorkerFunction?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoUrlCollection?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerRole?: Maybe<BffProviderRole>;
  providerType?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  reviewSummary?: Maybe<BffProviderReviewSummary>;
  reviews?: Maybe<Array<Maybe<BffReview>>>;
  socialNetworks?: Maybe<Array<Maybe<BffSocialNetworks>>>;
  specialties?: Maybe<Scalars['String']['output']>;
  stateLicense?: Maybe<Scalars['String']['output']>;
  volunteerism?: Maybe<Scalars['String']['output']>;
  workerType?: Maybe<Scalars['String']['output']>;
};

export type BffProviderCollection = {
  __typename?: 'BffProviderCollection';
  items?: Maybe<Array<Maybe<BffProvider>>>;
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BffProviderLicense = {
  __typename?: 'BffProviderLicense';
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BffProviderReviewSummary = {
  __typename?: 'BffProviderReviewSummary';
  averageRating?: Maybe<Scalars['Float']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Array<Maybe<BffRating>>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
};

export type BffProviderRole = {
  __typename?: 'BffProviderRole';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffRating = {
  __typename?: 'BffRating';
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
};

export type BffReview = {
  __typename?: 'BffReview';
  comments?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewId?: Maybe<Scalars['String']['output']>;
  reviewTimestamp?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<BffReviewReviewer>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BffReviewReviewer = {
  __typename?: 'BffReviewReviewer';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type BffReviews = {
  __typename?: 'BffReviews';
  averageRating?: Maybe<Scalars['Float']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Array<Maybe<BffRating>>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<Maybe<BffReview>>>;
};

export type BffSalesStatus = {
  __typename?: 'BffSalesStatus';
  effectiveFrom?: Maybe<Scalars['String']['output']>;
  effectiveThru?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BffService = {
  __typename?: 'BffService';
  activeFlag?: Maybe<Scalars['Boolean']['output']>;
  add_ons_info?: Maybe<Scalars['String']['output']>;
  additional_info?: Maybe<Scalars['String']['output']>;
  catalog_info?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  dentureCouponCode?: Maybe<Scalars['String']['output']>;
  dentureFee?: Maybe<Scalars['Int']['output']>;
  dentureFlag?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  finishing_services_info?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  generalDentFee?: Maybe<Scalars['Int']['output']>;
  generalDentistryCouponCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image_paths?: Maybe<Scalars['String']['output']>;
  is_couple_service?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parallel_groups?: Maybe<Scalars['String']['output']>;
  parallel_service_groups?: Maybe<Scalars['String']['output']>;
  prerequisites_info?: Maybe<Scalars['String']['output']>;
  price_info?: Maybe<BffPriceInfo>;
  procedureCategory?: Maybe<Scalars['String']['output']>;
  procedureCode?: Maybe<Scalars['String']['output']>;
  procedureDescription?: Maybe<Scalars['String']['output']>;
  promotionalPrice?: Maybe<Scalars['Int']['output']>;
  recovery_time?: Maybe<Scalars['Int']['output']>;
  variants_info?: Maybe<Scalars['String']['output']>;
};

export type BffServices = {
  __typename?: 'BffServices';
  error?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<BffService>>>;
};

export type BffSession = {
  __typename?: 'BffSession';
  Error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BffSlot = {
  __typename?: 'BffSlot';
  Available?: Maybe<Scalars['Boolean']['output']>;
  Priority?: Maybe<Scalars['Int']['output']>;
  SalePrice?: Maybe<Scalars['String']['output']>;
  Time?: Maybe<Scalars['String']['output']>;
  Warnings?: Maybe<Scalars['String']['output']>;
};

export type BffSlots = {
  __typename?: 'BffSlots';
  Error?: Maybe<Scalars['String']['output']>;
  future_days?: Maybe<Array<Maybe<BffFutureDays>>>;
  next_available_day?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<Maybe<BffSlot>>>;
};

export type BffSocialNetworks = {
  __typename?: 'BffSocialNetworks';
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BffSpecialtyService = {
  __typename?: 'BffSpecialtyService';
  name?: Maybe<Scalars['String']['output']>;
};

export type BffState = {
  __typename?: 'BffState';
  abbreviation?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
};

export type BffTimeSpan = {
  __typename?: 'BffTimeSpan';
  /** The LocalTime scalar type is a local time string (i.e., with no associated timezone) in 24-hr HH:mm:ss. */
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type BffTimezone = {
  __typename?: 'BffTimezone';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  standard_name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type BffUsCity = {
  __typename?: 'BffUSCity';
  centers?: Maybe<Array<Maybe<BffFacility>>>;
  city?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type BffWorkingHours = {
  __typename?: 'BffWorkingHours';
  date?: Maybe<Scalars['String']['output']>;
  open?: Maybe<BffTimeSpan>;
};

export type BffWorkinghours = {
  __typename?: 'BffWorkinghours';
  day_of_week?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  is_closed?: Maybe<Scalars['Boolean']['output']>;
  off_peak_end_time?: Maybe<Scalars['String']['output']>;
  off_peak_start_time?: Maybe<Scalars['String']['output']>;
  offline_end_time?: Maybe<Scalars['String']['output']>;
  offline_start_time?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
};

export type BrandfolderCustomField = {
  __typename?: 'BrandfolderCustomField';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BrandfolderDamVideoAsset = {
  __typename?: 'BrandfolderDamVideoAsset';
  customFields: Array<BrandfolderCustomField>;
  height?: Maybe<Scalars['Int']['output']>;
  imageOrder?: Maybe<Scalars['Int']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  streamingUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ConsentResponse = {
  __typename?: 'ConsentResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type IsClientInfo = {
  isNewClient: Scalars['Boolean']['input'];
  vetspireClientId?: InputMaybe<Scalars['Int']['input']>;
};

export type IsLovetLocation = {
  locationId: Scalars['Int']['input'];
  mainLocationId: Scalars['Int']['input'];
  state: Scalars['String']['input'];
};

export type IsNeedsBasedQuestion = {
  answerCodes: Array<Scalars['String']['input']>;
  questionCode: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type IsPatientInfo = {
  birthdate?: InputMaybe<Scalars['String']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  isEstimatedBirthdate?: InputMaybe<Scalars['Boolean']['input']>;
  isNewPatient: Scalars['Boolean']['input'];
  sex?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  sterilization?: InputMaybe<Scalars['String']['input']>;
  vetspirePatientId?: InputMaybe<Scalars['Int']['input']>;
};

export type IsQuestionnaire = {
  questionnaireCode: Scalars['String']['input'];
  questions: Array<IsNeedsBasedQuestion>;
};

export type IntelligentSchedulingPayload = {
  client?: InputMaybe<IsClientInfo>;
  lovetLocation?: InputMaybe<IsLovetLocation>;
  needsBasedQuestions?: InputMaybe<Array<InputMaybe<IsQuestionnaire>>>;
  patient?: InputMaybe<IsPatientInfo>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sourceChannel?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  consentManagement?: Maybe<ConsentResponse>;
  uploadPatientDocument: PatientDocument;
  uploadPatientImage: Patient;
};


export type MutationConsentManagementArgs = {
  brand: BffBrandType;
  payload: Scalars['JSON']['input'];
};


export type MutationUploadPatientDocumentArgs = {
  brand: BffBrandType;
  category?: InputMaybe<Scalars['String']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  encounterSectionName?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationUploadPatientImageArgs = {
  brand: BffBrandType;
  file: Scalars['Upload']['input'];
  patientId: Scalars['String']['input'];
};

export type NamedAttribute = {
  __typename?: 'NamedAttribute';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OneTrustConsentContent = {
  __typename?: 'OneTrustConsentContent';
  CreatedDate?: Maybe<Scalars['String']['output']>;
  DataElements?: Maybe<Array<Maybe<OneTrustDataElement>>>;
  Id?: Maybe<Scalars['String']['output']>;
  Identifier?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<Scalars['String']['output']>;
  LastUpdatedDate?: Maybe<Scalars['String']['output']>;
  Purposes?: Maybe<Array<Maybe<OneTrustPurpose>>>;
  TestDataSubject?: Maybe<Scalars['Boolean']['output']>;
};

export type OneTrustConsentPreferences = {
  __typename?: 'OneTrustConsentPreferences';
  content?: Maybe<Array<Maybe<OneTrustConsentContent>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<OneTrustPageable>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<OneTrustSort>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type OneTrustDataElement = {
  __typename?: 'OneTrustDataElement';
  Linked?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type OneTrustPageable = {
  __typename?: 'OneTrustPageable';
  offset?: Maybe<Scalars['Int']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  paged?: Maybe<Scalars['Boolean']['output']>;
  requestContinuation?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<OneTrustSort>;
  unpaged?: Maybe<Scalars['Boolean']['output']>;
};

export type OneTrustPurpose = {
  __typename?: 'OneTrustPurpose';
  ConsentDate?: Maybe<Scalars['String']['output']>;
  CustomPreferences?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  ExpiryDate?: Maybe<Scalars['String']['output']>;
  FirstTransactionDate?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  LastInteractionDate?: Maybe<Scalars['String']['output']>;
  LastReceiptId?: Maybe<Scalars['String']['output']>;
  LastTransactionCollectionPointId?: Maybe<Scalars['String']['output']>;
  LastTransactionCollectionPointVersion?: Maybe<Scalars['Int']['output']>;
  LastTransactionDate?: Maybe<Scalars['String']['output']>;
  LastUpdatedDate?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  PurposeNote?: Maybe<Scalars['String']['output']>;
  ReactivationDate?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Topics?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  TotalTransactionCount?: Maybe<Scalars['Int']['output']>;
  Version?: Maybe<Scalars['Int']['output']>;
  WithdrawalDate?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Scalars['JSON']['output']>;
};

export type OneTrustSort = {
  __typename?: 'OneTrustSort';
  empty?: Maybe<Scalars['Boolean']['output']>;
  sorted?: Maybe<Scalars['Boolean']['output']>;
  unsorted?: Maybe<Scalars['Boolean']['output']>;
};

export type Patient = {
  __typename?: 'Patient';
  id: Scalars['String']['output'];
  profileImageUrl: Scalars['String']['output'];
};

export type PatientDocument = {
  __typename?: 'PatientDocument';
  category?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['String']['output']>;
  encounterSectionName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  allProviders?: Maybe<Array<Maybe<BffProvider>>>;
  availabilityByLocation?: Maybe<BffLocationAvailability>;
  blogs?: Maybe<Array<Maybe<BffBlog>>>;
  brazeUserAttributes?: Maybe<BffBrazeUserAttributes>;
  client?: Maybe<BffClientList>;
  consentPreferences?: Maybe<OneTrustConsentPreferences>;
  createBooking?: Maybe<BffSession>;
  delegateQuery?: Maybe<Scalars['JSON']['output']>;
  delegateQueryVar?: Maybe<Scalars['JSON']['output']>;
  estimatesByClientId?: Maybe<Array<Maybe<BffEstimate>>>;
  facilitiesByAddress?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesBySearch?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByState?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateAndCity?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateCityAndStreet?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateCityAndZipcode?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByZipcode?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesScheduleType?: Maybe<Array<Maybe<BffFacilityScheduleType>>>;
  facilitiesViaGrpc?: Maybe<BffFacilityCollection>;
  facilityBrand?: Maybe<Array<Maybe<BffBrand>>>;
  facilityById?: Maybe<BffFacility>;
  facilityByLocation?: Maybe<Array<Maybe<BffFacility>>>;
  facilityCities?: Maybe<Array<Maybe<BffUsCity>>>;
  facilityCitiesByState?: Maybe<Array<Maybe<BffCity>>>;
  facilityCollection?: Maybe<BffFacilityCollection>;
  facilityMediaById?: Maybe<Array<Maybe<BrandfolderDamVideoAsset>>>;
  facilityPicById?: Maybe<Array<Maybe<BffDamAsset>>>;
  facilityStates?: Maybe<Array<Maybe<BffState>>>;
  geocode?: Maybe<BffGeocodeResult>;
  getCenters?: Maybe<BffCenters>;
  getServices?: Maybe<BffServices>;
  getSlots?: Maybe<BffSlots>;
  ordersByClientId?: Maybe<Array<Maybe<BffOrder>>>;
  productsWithIds?: Maybe<Array<Maybe<BffProduct>>>;
  providerById?: Maybe<BffProvider>;
  providerCollection?: Maybe<BffProviderCollection>;
  providerPicById?: Maybe<Array<Maybe<BffDamAsset>>>;
  providerPicByNpi?: Maybe<Array<Maybe<BffDamAsset>>>;
  providersByIdList?: Maybe<Array<Maybe<BffProvider>>>;
  reviewByFacility?: Maybe<BffReviews>;
  reviewSummaryByProvider?: Maybe<BffProviderReviewSummary>;
  reviews?: Maybe<BffReviews>;
  reviewsByProvider?: Maybe<Array<Maybe<BffReview>>>;
  reviewsSelection?: Maybe<Array<Maybe<BffReview>>>;
  states?: Maybe<Array<Maybe<BffState>>>;
  statesByAbbreviation?: Maybe<BffState>;
  statesByName?: Maybe<BffState>;
  workHours?: Maybe<Array<Maybe<BffWorkingHours>>>;
};


export type QueryAllProvidersArgs = {
  brand: BffBrandType;
};


export type QueryAvailabilityByLocationArgs = {
  appointmentTypes: Array<InputMaybe<AppointmentType>>;
  brand: BffBrandType;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  intelligentSchedulingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  intelligentSchedulingPayload?: InputMaybe<IntelligentSchedulingPayload>;
};


export type QueryBlogsArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
};


export type QueryBrazeUserAttributesArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryClientArgs = {
  brand: BffBrandType;
  phoneNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryConsentPreferencesArgs = {
  brand: BffBrandType;
  identifier: Scalars['String']['input'];
};


export type QueryCreateBookingArgs = {
  brand: BffBrandType;
  centerId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  isDoubleBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlyCatalogEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
};


export type QueryDelegateQueryArgs = {
  brand: BffBrandType;
  query: Scalars['String']['input'];
};


export type QueryDelegateQueryVarArgs = {
  brand: BffBrandType;
  operationName: Scalars['String']['input'];
  query: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryEstimatesByClientIdArgs = {
  brand: BffBrandType;
  clientId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFacilitiesByAddressArgs = {
  address: Scalars['String']['input'];
  brand: BffBrandType;
  defaultLatitude?: InputMaybe<Scalars['Float']['input']>;
  defaultLongitude?: InputMaybe<Scalars['Float']['input']>;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilitiesBySearchArgs = {
  address: Scalars['String']['input'];
  brand: BffBrandType;
  defaultLatitude?: InputMaybe<Scalars['Float']['input']>;
  defaultLongitude?: InputMaybe<Scalars['Float']['input']>;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilitiesByStateArgs = {
  brand: BffBrandType;
  state: Scalars['String']['input'];
};


export type QueryFacilitiesByStateAndCityArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type QueryFacilitiesByStateCityAndStreetArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};


export type QueryFacilitiesByStateCityAndZipcodeArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type QueryFacilitiesByZipcodeArgs = {
  brand: BffBrandType;
  defaultLatitude?: InputMaybe<Scalars['Float']['input']>;
  defaultLongitude?: InputMaybe<Scalars['Float']['input']>;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryFacilitiesScheduleTypeArgs = {
  brand: BffBrandType;
};


export type QueryFacilitiesViaGrpcArgs = {
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryFacilityByLocationArgs = {
  brand: BffBrandType;
  defaultLatitude?: InputMaybe<Scalars['Float']['input']>;
  defaultLongitude?: InputMaybe<Scalars['Float']['input']>;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityCitiesArgs = {
  brand: BffBrandType;
};


export type QueryFacilityCitiesByStateArgs = {
  brand: BffBrandType;
  state: Scalars['String']['input'];
};


export type QueryFacilityCollectionArgs = {
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityMediaByIdArgs = {
  brand: BffBrandType;
  code: Scalars['String']['input'];
};


export type QueryFacilityPicByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryFacilityStatesArgs = {
  brand: BffBrandType;
};


export type QueryGeocodeArgs = {
  address: Scalars['String']['input'];
  brand: BffBrandType;
};


export type QueryGetCentersArgs = {
  brand: BffBrandType;
  catalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetServicesArgs = {
  brand: BffBrandType;
  catalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  centerId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSlotsArgs = {
  bookingId: Scalars['String']['input'];
  brand: BffBrandType;
  checkFutureDayAvailablity?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrdersByClientIdArgs = {
  brand: BffBrandType;
  clientId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsWithIdsArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
  idList: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryProviderByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryProviderCollectionArgs = {
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProviderPicByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryProviderPicByNpiArgs = {
  brand: BffBrandType;
  npi: Scalars['String']['input'];
};


export type QueryProvidersByIdListArgs = {
  brand: BffBrandType;
  idList: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryReviewByFacilityArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
};


export type QueryReviewSummaryByProviderArgs = {
  brand: BffBrandType;
  npi: Scalars['String']['input'];
};


export type QueryReviewsArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
};


export type QueryReviewsByProviderArgs = {
  brand: BffBrandType;
  npi: Scalars['String']['input'];
};


export type QueryReviewsSelectionArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStatesByAbbreviationArgs = {
  abbreviation: Scalars['String']['input'];
};


export type QueryStatesByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryWorkHoursArgs = {
  brand: BffBrandType;
  facilityId: Scalars['String']['input'];
};

export type Token = {
  __typename?: 'Token';
  access_token?: Maybe<Scalars['String']['output']>;
};

export type AppointmentType =
  | 'GROOMING'
  | 'ROUTINE_CHECKUP'
  | 'SICK'
  | 'SICK_URGENT'
  | 'TECH_APPT'
  | 'VACCINE_BOOSTER';

export type BffBrandType =
  | 'ASPEN_DENTAL'
  | 'AZ_PET'
  | 'CHAPTER'
  | 'CLEAR_CHOICE'
  | 'LOVET'
  | 'MOTTO'
  | 'WELL_NOW';

export type IsClientInfo = {
  isNewClient: boolean;
  vetspireClientId?: number | null | undefined;
};

export type IsLovetLocation = {
  locationId: number;
  mainLocationId: number;
  state: string;
};

export type IsNeedsBasedQuestion = {
  answerCodes: Array<string>;
  questionCode: string;
  text?: string | null | undefined;
};

export type IsPatientInfo = {
  birthdate?: string | null | undefined;
  breed?: string | null | undefined;
  isEstimatedBirthdate?: boolean | null | undefined;
  isNewPatient: boolean;
  sex?: string | null | undefined;
  species?: string | null | undefined;
  sterilization?: string | null | undefined;
  vetspirePatientId?: number | null | undefined;
};

export type IsQuestionnaire = {
  questionnaireCode: string;
  questions: Array<IsNeedsBasedQuestion>;
};

export type IntelligentSchedulingPayload = {
  client?: IsClientInfo | null | undefined;
  lovetLocation?: IsLovetLocation | null | undefined;
  needsBasedQuestions?: Array<IsQuestionnaire | null | undefined> | null | undefined;
  patient?: IsPatientInfo | null | undefined;
  sessionId?: string | null | undefined;
  sourceChannel?: string | null | undefined;
};

export type ConsentManagementMutationVariables = Exact<{
  brand: BffBrandType;
  payload: unknown;
}>;


export type ConsentManagementMutation = { consentManagement: { message: string | null, success: boolean } | null };

export type AvailabilityByLocationQueryVariables = Exact<{
  brand: BffBrandType;
  facilityId: string;
  appointmentTypes: Array<AppointmentType | null | undefined> | AppointmentType;
  dateFrom: string;
  dateTo: string;
  intelligentSchedulingEnabled?: boolean | null | undefined;
  intelligentSchedulingPayload?: IntelligentSchedulingPayload | null | undefined;
}>;


export type AvailabilityByLocationQuery = { availabilityByLocation: { id: string, name: string, appointmentSlotMinutes: number, availableSlots: Array<{ date: string, time: string, type: string, providerId: string | null, provider: { username: string | null } | null }> } | null };

export type BffNamedAttributeFragment = { name: string | null, value: string | null };

export type BffNearbyFacilitiesByLocationQueryVariables = Exact<{
  brand: BffBrandType;
  latitude: number;
  longitude: number;
  radiusMiles?: number | null | undefined;
}>;


export type BffNearbyFacilitiesByLocationQuery = { facilityByLocation: Array<{ code: string, displayName: string | null, name: string | null, phoneNumber: string | null, scheduleAppointmentURL: string | null, address: { address1: string | null, address2: string | null, city: string | null, stateCode: string | null, zipCode: string | null } | null, location: { distance: number | null, latitude: number | null, longitude: number | null, timeZone: string | null, timezoneIANA: string | null } | null, attributes: Array<BffNamedAttributeFragment | null> | null } | null> | null };

export type CheckFacilitySupportByIdQueryVariables = Exact<{
  brand: BffBrandType;
  id: string;
}>;


export type CheckFacilitySupportByIdQuery = { facilityById: { id: string | null, name: string | null, displayName: string | null, phoneNumber: string | null, address: { address1: string | null, address2: string | null, city: string | null, stateCode: string | null, zipCode: string | null } | null, location: { latitude: number | null, longitude: number | null, timeZone: string | null, timezoneIANA: string | null } | null, attributes: Array<{ name: string | null, value: string | null } | null> | null } | null };

export const BffNamedAttributeFragmentDoc = gql`
    fragment BFFNamedAttribute on NamedAttribute {
  name
  value
}
    `;
export const ConsentManagementDocument = gql`
    mutation ConsentManagement($brand: BffBrandType!, $payload: JSON!) {
  consentManagement(brand: $brand, payload: $payload) {
    message
    success
  }
}
    `;

export function useConsentManagementMutation() {
  return Urql.useMutation<ConsentManagementMutation, ConsentManagementMutationVariables>(ConsentManagementDocument);
};
export const AvailabilityByLocationDocument = gql`
    query availabilityByLocation($brand: BffBrandType!, $facilityId: String!, $appointmentTypes: [AppointmentType]!, $dateFrom: String!, $dateTo: String!, $intelligentSchedulingEnabled: Boolean, $intelligentSchedulingPayload: IntelligentSchedulingPayload) {
  availabilityByLocation(
    brand: $brand
    facilityId: $facilityId
    appointmentTypes: $appointmentTypes
    dateFrom: $dateFrom
    dateTo: $dateTo
    intelligentSchedulingEnabled: $intelligentSchedulingEnabled
    intelligentSchedulingPayload: $intelligentSchedulingPayload
  ) {
    id
    name
    appointmentSlotMinutes
    availableSlots {
      date
      time
      type
      providerId
      provider {
        username
      }
    }
  }
}
    `;

export function useAvailabilityByLocationQuery(options: Omit<Urql.UseQueryArgs<AvailabilityByLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<AvailabilityByLocationQuery, AvailabilityByLocationQueryVariables>({ query: AvailabilityByLocationDocument, ...options });
};
export const BffNearbyFacilitiesByLocationDocument = gql`
    query bffNearbyFacilitiesByLocation($brand: BffBrandType!, $latitude: Float!, $longitude: Float!, $radiusMiles: Int) {
  facilityByLocation(
    brand: $brand
    latitude: $latitude
    longitude: $longitude
    radiusMiles: $radiusMiles
  ) {
    code
    displayName
    name
    phoneNumber
    address {
      address1
      address2
      city
      stateCode
      zipCode
    }
    scheduleAppointmentURL
    location {
      distance
      latitude
      longitude
      timeZone
      timezoneIANA
    }
    attributes {
      ...BFFNamedAttribute
    }
  }
}
    ${BffNamedAttributeFragmentDoc}`;

export function useBffNearbyFacilitiesByLocationQuery(options: Omit<Urql.UseQueryArgs<BffNearbyFacilitiesByLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<BffNearbyFacilitiesByLocationQuery, BffNearbyFacilitiesByLocationQueryVariables>({ query: BffNearbyFacilitiesByLocationDocument, ...options });
};
export const CheckFacilitySupportByIdDocument = gql`
    query checkFacilitySupportById($brand: BffBrandType!, $id: String!) {
  facilityById(brand: $brand, id: $id) {
    id
    name
    displayName
    phoneNumber
    address {
      address1
      address2
      city
      stateCode
      zipCode
    }
    location {
      latitude
      longitude
      timeZone
      timezoneIANA
    }
    attributes {
      name
      value
    }
  }
}
    `;

export function useCheckFacilitySupportByIdQuery(options: Omit<Urql.UseQueryArgs<CheckFacilitySupportByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckFacilitySupportByIdQuery, CheckFacilitySupportByIdQueryVariables>({ query: CheckFacilitySupportByIdDocument, ...options });
};